export const PLAYLIST_POPUP_OPENED = 'vjs-x-playlist-popup-opened'
export const MIDDLE_SEEK_CONTROLS_CLASS = 'middle-bunk-seek-controls'

export const INFO_BUTTON_CLASS = 'vjs-x-info-button'
export const PLAYLIST_BUTTON_CLASS = 'vjs-x-playlist-button'
